import useViewportTier from './useViewportTier';

/** True below the `s` breakpoint (<784px). Aligned to the theme breakpoints. */
export default function useIsMobile() {
  return useViewportTier() === 'mobile';
}
